var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelpass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "#535385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z",
    fill: "#535385"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_310_74)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_310_74",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 14,
    height: 15,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 8,
    width: 14,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7196 9.042H22.3156V22H20.9096V11.645L16.5776 22H15.2476L11.1056 11.683V22H9.68064V9.042H11.4286L15.9696 20.404L20.7196 9.042Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.7196 9.042H22.3156V22H20.9096V11.645L16.5776 22H15.2476L11.1056 11.683V22H9.68064V9.042H11.4286L15.9696 20.404L20.7196 9.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7196 9.042V8.642H20.4533L20.3506 8.88771L20.7196 9.042ZM22.3156 9.042H22.7156V8.642H22.3156V9.042ZM22.3156 22V22.4H22.7156V22H22.3156ZM20.9096 22H20.5096V22.4H20.9096V22ZM20.9096 11.645H21.3096L20.5406 11.4906L20.9096 11.645ZM16.5776 22V22.4H16.8439L16.9467 22.1544L16.5776 22ZM15.2476 22L14.8764 22.149L14.9772 22.4H15.2476V22ZM11.1056 11.683L11.4768 11.534L10.7056 11.683H11.1056ZM11.1056 22V22.4H11.5056V22H11.1056ZM9.68064 22H9.28064V22.4H9.68064V22ZM9.68064 9.042V8.642H9.28064V9.042H9.68064ZM11.4286 9.042L11.8001 8.89355L11.6995 8.642H11.4286V9.042ZM15.9696 20.404L15.5982 20.5524L15.9613 21.461L16.3387 20.5583L15.9696 20.404ZM20.7196 9.442H22.3156V8.642H20.7196V9.442ZM21.9156 9.042V22H22.7156V9.042H21.9156ZM22.3156 21.6H20.9096V22.4H22.3156V21.6ZM21.3096 22V11.645H20.5096V22H21.3096ZM20.5406 11.4906L16.2086 21.8456L16.9467 22.1544L21.2787 11.7994L20.5406 11.4906ZM16.5776 21.6H15.2476V22.4H16.5776V21.6ZM15.6188 21.851L11.4768 11.534L10.7344 11.832L14.8764 22.149L15.6188 21.851ZM10.7056 11.683V22H11.5056V11.683H10.7056ZM11.1056 21.6H9.68064V22.4H11.1056V21.6ZM10.0806 22V9.042H9.28064V22H10.0806ZM9.68064 9.442H11.4286V8.642H9.68064V9.442ZM11.0572 9.19045L15.5982 20.5524L16.3411 20.2556L11.8001 8.89355L11.0572 9.19045ZM16.3387 20.5583L21.0887 9.19628L20.3506 8.88771L15.6006 20.2497L16.3387 20.5583Z",
    fill: "white",
    mask: "url(#path-2-outside-1_310_74)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_310_74",
    x: 7.68066,
    y: 9.04199,
    width: 16.635,
    height: 16.958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_310_74"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_310_74",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelpass);
export default __webpack_public_path__ + "static/media/travelpass.eabbf2e18e11876a389e042b6d6a3f42.svg";
export { ForwardRef as ReactComponent };